import { Tabs as MUITabs, TabsProps } from '@mui/material';

export const Tabs = ({ ...props }: TabsProps) => <MUITabs {...props} />;
